export const VERTICALS = {
  living: {
    key: "living",
    name: "Living",
    fullName: "Archedia Living",
    tagline: "For the life you want to live.",
    cta: "Find My Home",
    perspectiveLabel: "Living Perspective",
    criteria: [
      { key: "lifestyleFit", label: "Lifestyle Fit" },
      { key: "commute", label: "Commute" },
      { key: "connectivity", label: "Connectivity" },
      { key: "space", label: "Space" },
      { key: "community", label: "Community" },
      { key: "education", label: "Education" },
      { key: "amenities", label: "Amenities" },
      { key: "longTerm", label: "Long-Term Suitability" },
    ],
  },
  invests: {
    key: "invests",
    name: "Invests",
    fullName: "Archedia Invests",
    tagline: "For the value you want to build.",
    cta: "Explore Investments",
    perspectiveLabel: "Investment Perspective",
    criteria: [
      { key: "entry", label: "Entry Position" },
      { key: "microMarket", label: "Micro-Market" },
      { key: "demand", label: "Demand" },
      { key: "rental", label: "Rental Potential" },
      { key: "infrastructure", label: "Infrastructure" },
      { key: "developer", label: "Developer Strength" },
      { key: "exit", label: "Exit Liquidity" },
    ],
  },
  luxe: {
    key: "luxe",
    name: "Luxe",
    fullName: "Archedia Luxe",
    tagline: "For the standard you choose to live by.",
    cta: "Explore Luxe",
    perspectiveLabel: "Luxe Perspective",
    criteria: [
      { key: "privacy", label: "Privacy" },
      { key: "scarcity", label: "Scarcity" },
      { key: "architecture", label: "Architecture" },
      { key: "spaceLuxe", label: "Space" },
      { key: "location", label: "Location" },
      { key: "pedigree", label: "Developer Pedigree" },
    ],
  },
};

// Living orbiting nodes for the "YOUR LIFE" visual
export const LIVING_NODES = [
  "Work", "Family", "Schools", "Lifestyle",
  "Space", "Community", "Connectivity", "Future Needs",
];

export const LIVING_DETAILS = {
  commute: {
    title: "Commute",
    lead: "Not simply distance.",
    points: [
      "Actual travel corridor",
      "Employment hubs",
      "Peak-hour connectivity",
      "Metro access",
      "Alternative routes",
      "Future infrastructure",
    ],
  },
  lifestyleFit: {
    title: "Lifestyle Fit",
    lead: "How a home resonates with how you live.",
    points: ["Daily rhythm", "Social fabric", "Indoor–outdoor balance", "Wellness access"],
  },
  connectivity: {
    title: "Connectivity",
    lead: "How the location connects to your world.",
    points: ["Arterial roads", "Public transit", "Airport access", "Digital infrastructure"],
  },
  space: {
    title: "Space",
    lead: "Beyond square footage.",
    points: ["Usable carpet area", "Ceiling volume", "Natural light", "Storage & flow"],
  },
  community: {
    title: "Community",
    lead: "Who you live around matters.",
    points: ["Resident profile", "Density", "Shared amenities", "Management quality"],
  },
  education: {
    title: "Education",
    lead: "Access to learning ecosystems.",
    points: ["School catchment", "Reputed institutions", "Commute to campus", "Future capacity"],
  },
  amenities: {
    title: "Amenities",
    lead: "Utility over indulgence.",
    points: ["Everyday convenience", "Wellness & recreation", "Maintenance viability", "Safety systems"],
  },
  longTerm: {
    title: "Long-Term Suitability",
    lead: "Will it still fit you in ten years?",
    points: ["Family evolution", "Resale liquidity", "Neighbourhood trajectory", "Ageing-in-place"],
  },
};

// Investment flow stages
export const INVEST_FLOW = ["Market", "Micro-Market", "Developer", "Project", "Entry", "Demand", "Exit"];

export const INVEST_SECTIONS = [
  { key: "microMarket", title: "Micro-Market", points: ["Infrastructure", "Employment", "Residential demand", "Upcoming supply", "Connectivity"] },
  { key: "entry", title: "Entry", points: ["Current positioning", "Comparable projects", "Stage of development", "Pricing context"] },
  { key: "demand", title: "Demand", points: ["End-user demand", "Rental demand", "Employment catchment", "Absorption indicators"] },
  { key: "future", title: "Future", points: ["Infrastructure catalysts", "Upcoming development", "Supply pipeline", "Growth drivers"] },
  { key: "exit", title: "Exit", points: ["Potential buyer pool", "Holding horizon", "Resale dynamics", "Liquidity"] },
];

// Luxe matrix comparison pairs
export const LUXE_MATRIX = [
  { a: "Space", b: "Density" },
  { a: "Privacy", b: "Accessibility" },
  { a: "Scarcity", b: "Supply" },
  { a: "Architecture", b: "Functionality" },
  { a: "Location", b: "Exclusivity" },
];

export const LUXE_WORDS = ["Space", "Privacy", "Scarcity", "Architecture", "Location", "Exclusivity", "Lifestyle", "Pedigree"];

// The Archedia difference dimensions
export const DIFFERENCE_DIMENSIONS = [
  "Purpose", "Budget", "Lifestyle", "Micro-Market", "Developer", "Entry Price",
  "Infrastructure", "Demand", "Supply", "Rental Potential", "Timeline", "Exit",
];

export const JOURNEY_STEPS = [
  { no: "01", title: "Understand", desc: "We begin with why you are buying, not what is available." },
  { no: "02", title: "Evaluate", desc: "Market, micro-market, developer and property, measured against your priorities." },
  { no: "03", title: "Curate", desc: "A short, considered set of opportunities — not an endless list." },
  { no: "04", title: "Experience", desc: "Guided visits and perspective, so you see beyond the brochure." },
  { no: "05", title: "Decide", desc: "A confident decision, built on perspective." },
];

export function advisoryLabel(score) {
  if (score >= 85) return "Exceptional";
  if (score >= 72) return "Strong";
  if (score >= 58) return "Balanced";
  if (score >= 45) return "Considered";
  return "Selective";
}

export function verticalCriteria(key) {
  return VERTICALS[key]?.criteria || [];
}
